import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "message-author" }
const _hoisted_3 = { class: "message-content mt-1" }


import { ChatMessage } from '@/models/chat.model';
import { useMembersStore } from '@/stores/MembersStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChatMessage',
  props: {
  message: ChatMessage
},
  setup(__props) {



const membersStore = useMembersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "message",
    id: __props.message?.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", null, _toDisplayString(_unref(membersStore).memberUsername(__props.message?.userId)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.message?.message), 1)
  ], 8, _hoisted_1))
}
}

})